import { request } from "@/utils/remoteRequest";

export function getResumePage(data) {
  return request({
    url: "/resumeInfo/searchViewMyPostSendForPage",
    method: "post",
    data,
  });
}

export function getUniversity(data) {
  return request({
    url: "/orgManage/getUniversity",
    method: "post",
    data,
  });
}
